import axiosClient from "./axiosClient";
// import { IClientRegisterLeaderboard, IGetLeaderboardDetail } from "@interfaces";

export const campaignAPI = {
    getCampaign: (params: string) => {
        const url = "clients/campaigns/";
        return axiosClient.get(url + params);
    },
    getCampaignList: (params: string) => {
        const url = "clients/campaigns";
        return axiosClient.get(url + params);
    },
    clientRegisterCampaign: (values: any) => {
        const url = `clients/campaigns/${values}/join`;
        return axiosClient.post(url);
    },
    getMyCampaignData: (id: string) => {
        const url = `clients/campaigns/${id}/me`;
        return axiosClient.get(url);
    },
    getUserCampaignData: (id: string, params: string) => {
        const url = `clients/campaigns/${id}/users`;
        return axiosClient.get(url + params);
    },
    uploadCampaign: (id: string, values: any) => {
        const url = `clients/campaigns/${id}/me/upload`;
        return axiosClient.post(url, values);
    },
    getHistoryActivity: (id: string, params: string) => {
        const url = `clients/campaigns/${id}/me/histories`;
        return axiosClient.get(url + params);
    },
};
